import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="novtia-footer">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row justify-between gap-8">
        <div>
          <span className="font-mono tracking-[0.22em] text-xs block mb-2">
            NOVTIA
          </span>
          <p className="text-sm mb-1">
            Governed AI systems for high-stakes operations.
          </p>
          <p className="text-xs mb-1">London, UK · nov-tia.com</p>
          <p className="text-xs">
            © {new Date().getFullYear()} NOVTIA LTD. All rights reserved.
          </p>
        </div>
        <div className="flex flex-wrap gap-10">
          <div className="flex flex-col gap-2">
            <span className="kicker mb-1">Explore</span>
            <Link to="/products" className="text-sm">
              Products
            </Link>
            <Link to="/services" className="text-sm">
              Services
            </Link>
            <Link to="/about" className="text-sm">
              About
            </Link>
            <Link to="/insights" className="text-sm">
              Insights
            </Link>
            <Link
              to="/case-studies"
              className="text-sm"
            >
              Case Studies
            </Link>
            <Link to="/labs" className="text-sm">
              NOVTIA Labs
            </Link>
          </div>
          <div className="flex flex-col gap-2">
            <span className="kicker mb-1">Connect</span>
            <a
              href="mailto:contact@nov-tia.com"
              className="text-sm"
            >
              contact@nov-tia.com
            </a>
            <Link to="/contact" className="text-sm">
              Start a conversation
            </Link>
            <a
              href="https://www.linkedin.com/company/novtia/about/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
